export async function runStorageMigration() {
  
  if (typeof window === 'undefined') return;

  try {
    const config = useRuntimeConfig();
    const APP_VERSION = config.public.appVersion;

    const storedVersion = localStorage.getItem('app_version');

    if (!storedVersion || storedVersion !== APP_VERSION) {
      console.log('Running migration for version:', APP_VERSION);

      localStorage.removeItem('location');
      localStorage.removeItem('geolocation');
      localStorage.removeItem('checkout');

      localStorage.setItem('app_version', APP_VERSION);

      window.location.reload();
    }
  } catch (err) {
    console.error('Storage migration error:', err);
  }
}